module.exports = __webpack_public_path__ + "static/media/en.81100991.svg";